import React from 'react'

const Select = ({ defaultOption, label, name, onChangeEvent, options, value }) => {
  let selectOptions = []

  for (let optionKey in options) {
    selectOptions.push(
      <option
        key={options[optionKey].value ? options[optionKey].value : options[optionKey]}
        value={options[optionKey].value ? options[optionKey].value : options[optionKey]}
      >
        {options[optionKey].label ? options[optionKey].label : options[optionKey]}
      </option>
    )
  }

  return (
    <label id={name + 'label'} className="u-form__label" htmlFor={name}>
      {label && <span className="u-form__label-text">{label}</span>}
      <div className="u-form__select-container">
        <select
          className="u-form__select"
          onChange={e => onChangeEvent(e)}
          aria-labelledby={name + 'label'}
          value={value}
        >
          {defaultOption && <option value={defaultOption.value}>{defaultOption.label}</option>}

          {selectOptions}
        </select>
      </div>
    </label>
  )
}

export default Select
